import { useEffect, useRef } from "react";
import "./Hero.css";
import useParallax from "../Animaciones/useParallax";

function Hero({ onReservar }) {
  const parallaxFoto = useParallax(0.1, 30);
  const heroRef = useRef(null);
  const luzRef = useRef(null);

  useEffect(() => {
    const esDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const prefiereMenosMovimiento = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!esDesktop || prefiereMenosMovimiento) return;

    const seccion = heroRef.current;
    const luz = luzRef.current;
    if (!seccion || !luz) return;

    const manejarMouseMove = (e) => {
      const rect = seccion.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      luz.style.transform = `translate(${x}px, ${y}px)`;
    };

    seccion.addEventListener("mousemove", manejarMouseMove);
    return () => seccion.removeEventListener("mousemove", manejarMouseMove);
  }, []);

  return (
    <section className="hero" id="inicio" ref={heroRef}>
      <div className="hero-luz-cursor" ref={luzRef} aria-hidden="true"></div>

      <div className="hero-lado-vertical">
        <span>Glowroom MVD</span>
      </div>

      <div className="hero-contenido">
        <h1 className="hero-titulo">
          <span className="hero-anim-izq">Tu mejor</span>
          <br />
          <span className="hero-anim-der hero-anim-delay-1">versión,</span>
          <br />
          <em className="hero-anim-izq hero-anim-delay-2">empieza acá.</em>
        </h1>

        <p className="hero-lema">
          <span className="hero-lema-palabra hero-lema-delay-1">Tu estilo.</span>{" "}
          <span className="hero-lema-palabra hero-lema-delay-2">Tu esencia.</span>{" "}
          <span className="hero-lema-palabra hero-lema-delay-3">Tu Glow.</span>
        </p>

        <div className="hero-botones">
          <button className="btn-principal btn-reservar-animado" onClick={onReservar}>
            Reservar turno
          </button>
        </div>

        <div className="hero-destacados">
          <div className="hero-destacado">
            <span className="destacado-icono">✦</span>
            <div>
              <p className="destacado-titulo">Atención personalizada</p>
              <p className="destacado-texto">Cada servicio pensado para vos</p>
            </div>
            <span className="destacado-icono">✦</span>
          </div>
          <div className="hero-destacado">
            <span className="destacado-icono">✦</span>
            <div>
              <p className="destacado-titulo">Calidad y detalle</p>
              <p className="destacado-texto">En cada trabajo</p>
            </div>
            <span className="destacado-icono">✦</span>
          </div>
        </div>
      </div>

      <div className="hero-imagen-col">
        <div className="hero-imagen-inner">
          <img
            ref={parallaxFoto}
            src="/cata.jpg"
            alt="Cata - Glowroom MVD"
            className="hero-foto-cata"
            fetchPriority="high"
          />
        </div>
        <div className="hero-imagen-overlay"></div>
      </div>
    </section>
  );
}

export default Hero;
